import React from 'preact/compat';
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Button, ModalWrapper } from 'list/DesignSystem';
import { ModalFooter, Prompt } from '@ingka/modal';
import translate from 'list/utils/translate';
import fetchPhraseIfNeeded from 'list/utils/fetch-phrase-if-needed';

const InspirationsRemovedModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const onUserHasAcknowledged = () => {
        setIsModalOpen(false);
    };
    useEffect(() => {
        window.ikea.pubsub.subscribe(
            'UNAVAILABLE_INSPIRATIONS_REMOVED',
            async (inspirationsRemovedQuantity: number) => {
                await fetchPhraseIfNeeded();
                setQuantity(inspirationsRemovedQuantity);
                setIsModalOpen(true);
            }
        );
    }, []);

    if (!isModalOpen) {
        return null;
    }

    const title =
        quantity > 1
            ? translate('UNAVAILABLE_INSPIRATIONS_REMOVED_MULTIPLE title')
            : translate('UNAVAILABLE_INSPIRATIONS_REMOVED title');
    const body =
        quantity > 1
            ? translate('UNAVAILABLE_INSPIRATIONS_REMOVED_MULTIPLE details', { count: quantity.toString() })
            : translate('UNAVAILABLE_INSPIRATIONS_REMOVED details');
    return (
        <ModalWrapper visible={isModalOpen} handleCloseBtn={() => setIsModalOpen(false)}>
            <Prompt
                title={title}
                footer={
                    <ModalFooter>
                        <Button
                            key="close"
                            type="primary"
                            text={translate('modal_close')}
                            onClick={onUserHasAcknowledged}
                        />
                    </ModalFooter>
                }
            >
                <p>{body}</p>
            </Prompt>
        </ModalWrapper>
    );
};

export default InspirationsRemovedModal;
